import {view} from '@sail/ui/deprecated';

type Props = {
  position?: 'center' | 'start' | 'end';
  children: React.ReactNode;
};

export const ChatRowContainer = ({
  position = 'start',
  children,
}: Props): JSX.Element => (
  <view.div
    data-testid="chat-row-container"
    css={{
      layout: 'row',
      alignX: position,
      gap: 'small',
    }}
  >
    {children}
  </view.div>
);
